import { Api, createUri } from './utils';

export enum BannerScope {
    Global = 'global',
    Company = 'company',
    Reseller = 'reseller',
    Location = 'location',
}

export enum BannerUrls {
    Banners = 'banners',
}

export type BannerListItem = {
    BannerID: number;
    CompanyID: number | null;
    DisplayOrder: number;
    ImageMimeType: string;
    UpdatedAt: string;
    SignedUrl: string;
};

export type BannerAddition = {
    imageBase64: string;
    mimeType: string;
    displayOrder: number;
};

export type BannerUpdate = {
    bannerId: number;
    displayOrder: number;
};

export type BannersBulkRequest = {
    scope: BannerScope;
    companyId?: number;
    additions: BannerAddition[];
    updates: BannerUpdate[];
    deletions: number[];
};

export type BannersResponse = {
    banners: BannerListItem[];
};

export const BANNERS_API_BASE = createUri(Api.Orgs, '/org/V1');

export const ALLOWED_BANNER_MIME_TYPES = [
    'image/png',
    'image/jpeg',
    'image/gif',
    'image/webp',
] as const;

export const MAX_BANNER_BYTES = 4 * 1024 * 1024;

/**
 * Banners are displayed under `object-fit: cover` on both the rc and rcmini
 * kiosks; rcmini is the tighter container, so its dimensions drive the spec.
 */
export const BANNER_DIMENSIONS = {
    minWidth: 500,
    minHeight: 200,
    aspectWidth: 5,
    aspectHeight: 2,
    aspectTolerance: 0.01,
} as const;

